import { get, ref, set } from "firebase/database";
import { db } from "../lib/firebase";
import { getPathDatabaseByRole } from "./auth";
import { LaunchError } from "../utils/errors";
import {
  pickPlatformDefaultsLoadData,
  pickPlatformDefaultsPayload,
} from "../utils/platformDefaults/platformDefaultsSavedFields";

const getAdvertiserDefaultPlatformValuesPath = ({ advertiserID, platform }) =>
  `advertisersDefaultPlatformValues/${advertiserID}/${platform}`;

export const startGetAdvertiserDefaultPlatformValues =
  ({ platform }) =>
  async (dispatch) => {
    try {
      const { userID } = dispatch(getPathDatabaseByRole());
      const path = getAdvertiserDefaultPlatformValuesPath({
        advertiserID: userID,
        platform,
      });
      const snapshot = await get(ref(db, path));

      if (!snapshot.exists()) {
        return { ok: true, data: null };
      }

      const data = pickPlatformDefaultsLoadData({
        data: snapshot.val() || {},
      });

      return { ok: true, data };
    } catch (error) {
      dispatch(
        LaunchError(error, true, [], {
          functionName: "startGetAdvertiserDefaultPlatformValues",
          context: { platform },
          tags: { action: "getAdvertiserDefaultPlatformValues" },
          level: "error",
        })
      );
      return { ok: false };
    }
  };

export const startSaveAdvertiserDefaultPlatformValues =
  ({ platform, values }) =>
  async (dispatch) => {
    try {
      const { userID } = dispatch(getPathDatabaseByRole());
      const path = getAdvertiserDefaultPlatformValuesPath({
        advertiserID: userID,
        platform,
      });
      const payload = pickPlatformDefaultsPayload({
        candidate: values,
      });

      await set(ref(db, path), payload);
      return { ok: true };
    } catch (error) {
      dispatch(
        LaunchError(error, true, [], {
          functionName: "startSaveAdvertiserDefaultPlatformValues",
          context: { platform },
          tags: { action: "saveAdvertiserDefaultPlatformValues" },
          level: "error",
        })
      );
      return { ok: false };
    }
  };
